import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mms",
  "use": "icon-mms-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mms\"><path d=\"M512 245.312a138.688 138.688 0 1 0 0 277.376 138.688 138.688 0 0 0 0-277.376zM437.312 384a74.688 74.688 0 1 1 149.376 0 74.688 74.688 0 0 1-149.376 0z\" /><path d=\"M512 53.312a458.688 458.688 0 0 0-324.096 783.232 32.064 32.064 0 0 0 7.744 7.616A457.152 457.152 0 0 0 512 970.688a457.088 457.088 0 0 0 322.304-132.352A458.688 458.688 0 0 0 512 53.312z m316.032 695.04a245.44 245.44 0 0 0-230.72-161.664H426.688a245.44 245.44 0 0 0-230.72 161.728 394.688 394.688 0 1 1 632.128 0z m-580.672 56.448a181.376 181.376 0 0 1 179.328-154.112h170.624a181.376 181.376 0 0 1 179.328 154.112A393.216 393.216 0 0 1 512 906.688a393.216 393.216 0 0 1-264.64-101.888z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mms.svg
// module id = 3QCR
// module chunks = 55